import React from 'react'
import { createGraphiQLFetcher } from '@graphiql/toolkit'
import GraphiQLComponent from 'graphiql'
import Box from 'transfix-ui/core/Box'
import { getUserCookieValues } from 'utils/userAuth'
import 'graphiql/graphiql.css'

const { authToken, email, userId } = getUserCookieValues()

const fetcher = createGraphiQLFetcher({
  headers: {
    'x-user-email': email,
    'x-user-token': authToken,
    'x-user-id': userId,
  },
  url: __GRAPHQL_ENDPOINT__,
})

function GraphiQL() {
  return (
    <Box height='100vh'>
      <GraphiQLComponent fetcher={fetcher} editorTheme='dracula' />
    </Box>
  )
}

export default GraphiQL
